module.exports = __webpack_public_path__ + "img/Evergreen_Acorn.02d31522.png";